import { render } from "./EmploymentList.vue?vue&type=template&id=4ad1a9b6"
import script from "./EmploymentList.vue?vue&type=script&lang=js"
export * from "./EmploymentList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__